import { Column } from './types';
import { formatDateTime } from 'utils/helpers';

export const reportHeaderTagLine = `Report produced on ${formatDateTime(new Date())}`;

export const All_SITE_CONNECTION_REPORT = 'All site connections';

export const ALL_SITE_CONNECTIONS_REPORT_MESSAGE_LINK = "https://ppgpinetree.atlassian.net/wiki/spaces/AE/pages/2366177294/All+Sites+Connections+Report"

export const ALL_SITE_CONNECTIONS_REPORT_GRID_TITLE =
  'allSitesConnectionsReport';

export const columns: Column[] = [
  { name: 'repairerGroup', title: 'Group', width: '150' },
  { name: 'siteCode', title: 'Site Code', width: '150' },
  { name: 'capsInboundConnection', title: 'CAPS Code', width: '150' },
  { name: 'accountStatus', title: 'Account Status', width: '150' },
  { name: 'subscriptionType', title: 'Subscription Type', width: '150' },
  { name: 'name', title: 'Name', width: '120' },
  { name: 'address', title: 'Address', width: '150' },
  { name: 'postcode', title: 'Postcode', width: '100' },
  { name: 'systemType', title: 'System Type', width: '150' },
  { name: 'audatex', title: 'Audatex ID', width: '150' },
  { name: 'capsOutboundConnections', title: 'CAPS Connections', width: '150' },
  { name: 'admiral', title: 'Admiral', width: '150' },
  { name: 'allianz', title: 'Allianz', width: '150' },
  { name: 'coveaCode', title: 'Covea', width: '150' },
  { name: 'dlgNetwork', title: 'DLG', width: '150' },
  { name: 'esure', title: 'Esure', width: '150' },
  { name: 'itasNetwork', title: 'ITAS', width: '150' },
  { name: 'kindertons', title: 'KINDERTONS', width: '150' },
  { name: 'lvConnection', title: 'LV', width: '150' },
  { name: 'nargNetwork', title: 'NARG', width: '150' },
  { name: 'rsa', title: 'RSA', width: '150' },
];
